import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { RESULTS_TYPE } from 'dpl/constants/query_params';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

export default function ResultsTypeSelector({ resultsType, locked }) {
  const dispatch = useDispatch();

  return (
    <div className="ResultsTypeSelector overflow-hidden fw-medium font-16-mobile bg-sand pt1 mb6">
      <div className="container flex">
        <button
          type="button"
          onClick={() => {
            dispatch(resetParams(RESULTS_TYPE));
            dispatch(
              pushParams(
                { [RESULTS_TYPE]: RESULTS_TYPES.PUPPIES },
                { hash: true }
              )
            );
          }}
          className={classnames('ResultsTypePuppies search-tab mr5', {
            'bb selected-tab-underline': resultsType === RESULTS_TYPES.PUPPIES,
            tertiary: resultsType !== RESULTS_TYPES.PUPPIES
          })}
          disabled={locked}
        >
          Puppies
        </button>
        <button
          type="button"
          onClick={() => {
            dispatch(
              pushParams(
                { [RESULTS_TYPE]: RESULTS_TYPES.BREEDERS },
                { hash: true }
              )
            );
          }}
          className={classnames('ResultsTypeBreeders search-tab', {
            'bb selected-tab-underline': resultsType === RESULTS_TYPES.BREEDERS,
            tertiary: resultsType !== RESULTS_TYPES.BREEDERS
          })}
          disabled={locked}
        >
          Breeders
        </button>
      </div>
    </div>
  );
}

ResultsTypeSelector.propTypes = {
  resultsType: PropTypes.string,
  locked: PropTypes.bool
};

ResultsTypeSelector.defaultProps = {
  resultsType: '',
  locked: false
};
